// Downscale an image File to a JPEG and return raw base64 (no
// data: prefix) for Gemini vision inlineData. Body photos for the
// physique check are never uploaded/stored — this keeps them in
// memory only.
const MAX_EDGE = 1024
const JPEG_QUALITY = 0.82

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => { URL.revokeObjectURL(url); resolve(img) }
    img.onerror = (err) => { URL.revokeObjectURL(url); reject(err) }
    img.src = url
  })
}

// Resolves { base64, mime, dataUrl }. base64 is the raw payload (for
// the API); dataUrl is for an in-memory preview <img>.
export async function imageToBase64(file) {
  const img = await loadImage(file)
  const { naturalWidth: w, naturalHeight: h } = img
  const scale = Math.min(1, MAX_EDGE / Math.max(w, h))
  const outW = Math.round(w * scale)
  const outH = Math.round(h * scale)

  const canvas = document.createElement('canvas')
  canvas.width = outW
  canvas.height = outH
  const ctx = canvas.getContext('2d')
  ctx.imageSmoothingEnabled = true
  ctx.imageSmoothingQuality = 'high'
  ctx.drawImage(img, 0, 0, outW, outH)

  const dataUrl = canvas.toDataURL('image/jpeg', JPEG_QUALITY)
  const base64 = dataUrl.split(',')[1] || ''
  return { base64, mime: 'image/jpeg', dataUrl }
}
